import { on } from 'delegated-events'

const SELECTORS = Selectors({
  cartPage: 'store-cart-page',
  cartItem: 'store-cart-item',
  cartItemPrice: 'store-cart-item__subtotal .price',
  cartSummary: 'store-cart-summary',
  removeForm: 'store-cart-remove-form',
  siteNavCart: 'site-nav__cart',
  qty: 'store-cart-item__qty input[type=text]',
  qtyButton: 'store-cart-item__qty button',
  qtyMinusButton: 'store-cart-item__qty-minus',
  qtyPlusButton: 'store-cart-item__qty-plus'
})

const props = {
  $cartPage: document.querySelector(SELECTORS.asClass('cartPage')),
  $cartSummary: document.querySelector(SELECTORS.asClass('cartSummary')),
  $siteNavCart: document.querySelector(SELECTORS.asClass('siteNavCart'))
}

const fn = {
  init: () => {
    fn.bindEvents()
  },

  bindEvents: () => {
    on('submit', SELECTORS.asClass('removeForm'), fn.handleRemove)
    on('click', SELECTORS.asClass('qtyMinusButton'), fn.handleDecreaseQty)
    on('click', SELECTORS.asClass('qtyPlusButton'), fn.handleIncreaseQty)
  },

  handleRemove: (e) => {
    e.preventDefault();

    const $form = e.target
    const $item = $form.closest(SELECTORS.asClass('cartItem'))
    const $submitButton = $form.querySelector('[type=submit]')

    if (!confirm('Are you sure you want to remove this item?')) {
      return false
    }

    $submitButton.disabled = true

    ajax.post($form.action, new FormData($form))
      .then((resp) => {
        if (resp.data.success) {
          // Remove item row
          $item.parentNode.removeChild($item)

          // Update the site nav cart count
          const $currentCartCount = props.$siteNavCart.querySelector('span')
          $currentCartCount.textContent = resp.data.cart_count

          if (resp.data.empty_cart) {
            props.$siteNavCart.classList.add('site-nav__cart--empty')
            props.$cartPage.classList.add('store-cart-page--empty')
          } else {
            props.$cartSummary.innerHTML = resp.data.cart_summary_html
          }
        }
      })
      .finally(() => {
        $submitButton.disabled = false
      })
  },

  handleDecreaseQty: (e) => {
    const $form = e.target.closest('form')
    const $qty = e.target.parentNode.querySelector(SELECTORS.asClass('qty'))
    const value = parseInt($qty.value)
    const newValue = value - 1

    if (newValue > 0) {
      $qty.value = newValue

      fn.updateRequest($form, -1)
    }
  },

  handleIncreaseQty: (e) => {
    const $form = e.target.closest('form')
    const $qty = e.target.parentNode.querySelector(SELECTORS.asClass('qty'))
    const value = parseInt($qty.value)
    const newValue = value + 1

    $qty.value = newValue

    fn.updateRequest($form, 1)
  },

  updateRequest: ($form, delta) => {
    fn.disableQtyButtons()

    const formData = new FormData($form)
    formData.append('Delta', delta)

    const $itemSubtotal = $form.closest(SELECTORS.asClass('cartItem')).querySelector(SELECTORS.asClass('cartItemPrice'))

    ajax.post($form.action, formData)
      .then((resp) => {
        if (resp.data.success) {
          $itemSubtotal.textContent = resp.data.product_subtotal
          props.$cartSummary.innerHTML = resp.data.cart_summary_html
        }
      })
      .finally(() => {
        fn.enableQtyButtons()
      })
  },

  disableQtyButtons: () => {
    document.querySelectorAll(SELECTORS.asClass('qtyButton')).forEach(b => b.disabled = true)
  },

  enableQtyButtons: () => {
    document.querySelectorAll(SELECTORS.asClass('qtyButton')).forEach(b => b.disabled = false)
  }
}

export default {
  can: () => props.$cartPage,
  run: fn.init
}
